import { component } from 'picoapp'
import $ from '../lib/quantdom'
import { get } from '../lib/ajax'
import { sessionStorageSetItem } from '../lib/utils'

export default component((node) => {
  $(node).on('click', (e) => {
    e.preventDefault()
    const url = new URL(window.location)
    url.searchParams.set('sort_by', $(e.target).attr('sort-value'))
    const urlPath = url.pathname + url.search

    $('.js-sort-link').attr('aria-selected', 'false')
    $(e.target).attr('aria-selected', 'true')

    if (sessionStorage.getItem(urlPath)) {
      replaceHTML(url, sessionStorage.getItem(urlPath), false)
    }
    url.searchParams.set('view', 'product-cards')
    get(url)
      .then((res) => {
        let currentActiveLink = $('.js-sort-link[aria-selected="true"]').attr('sort-value')
        if (currentActiveLink === url.searchParams.get('sort_by')) {
          url.searchParams.delete('view')
          replaceHTML(url, res)
        }
      })
      .catch((err) => {
        $(e.target).attr('aria-selected', 'false')
        console.log('Could not get collection', err)
      })
  })

  function replaceHTML(url, res, pushState = true) {
    const urlPath = url.pathname + url.search
    const parser = new DOMParser()
    const doc = parser.parseFromString(res, 'text/html')
    const el = doc.querySelector('.js-product-grid')
    const html = el.innerHTML
    const loadMoreState = el.getAttribute('data-load-more-hidden')
    const totalProducts = el.getAttribute('data-product-count')
    const productsPerPage = el.getAttribute('data-products-per-page')

    $('.js-load-more-wrapper').attr('aria-hidden', loadMoreState)
    $('.js-product-grid').html(html)
    $('.js-product-grid').attr('data-products-per-page', productsPerPage)
    $('.js-product-grid').attr('data-product-count', totalProducts)

    if (window?.productScroll && window?.productScroll?.active) {
      window.productScroll.stop()
    }

    sessionStorageSetItem(urlPath, res)
    if (pushState) {
      history.pushState({}, '', url)
    }
  }
})
